function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.707 18.293a.999.999 0 010 1.414l-4 3.999a.996.996 0 01-1.089.217 1.011 1.011 0 01-.326-.217l-3.999-3.999a.999.999 0 111.414-1.414L16 20.586V1a1 1 0 012 0v19.586l2.293-2.293a.999.999 0 011.414 0zm-10-14a.999.999 0 11-1.414 1.414L8 3.414V23a1 1 0 01-2 0V3.414L3.707 5.707a.999.999 0 11-1.414-1.414l4-3.999a1 1 0 011.414 0l4 3.999z"
});

var SvgIconSwapVertical = function SvgIconSwapVertical(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconSwapVertical;